import { ILocation, Location } from "./Location";

export enum LocationType {
  RemoteAnywhere = "remote_anywhere",
  RemoteCountries = "remote_countries",
  RemoteTimezones = "remote_timezones",
  Hybrid = "hybrid",
  PhysicalLocation = "physical_location"
}

export interface IPlace {
  remote: boolean;
  locationType?: LocationType;
  anywhere: boolean | undefined;
  timezone: boolean | undefined;
  location: ILocation[];
}

export class Place {

  public static Test(): Place {
    return new Place({
      remote: true,
      anywhere: undefined,
      timezone: undefined,
      location: []
    });
  }

  public remote: boolean;
  public locationType?: LocationType;
  public anywhere: boolean | undefined;
  public timezone: boolean | undefined;
  public location: Location[];

  constructor(data: IPlace) {
    this.remote = data.remote;
    this.locationType = data.locationType;
    this.anywhere = data.anywhere;
    this.timezone = data.timezone;
    this.location = data.location;
  }
}
